import { ReactNode } from 'react';

import { useFeatureFlagsStatus } from '@speeki/feature-flags';

import { SkeletonDashboardPage } from '@domains/dashboard/DashboardPage.skeleton';

import { AppWrapper } from './App.styled';

interface AppLoadingProps {
    children: ReactNode;
}

export const AppLoading = ({ children }: AppLoadingProps) => {
    const { flagsReady } = useFeatureFlagsStatus();

    return (
        <AppWrapper>
            {!flagsReady ? <SkeletonDashboardPage /> : children}
        </AppWrapper>
    );
};
